import { styled } from '@mui/material/styles';

import { SelectMenu, SelectMenuProps } from '../../atoms/SelectMenu';

export const StyledSelectMenu = styled(SelectMenu)((props: SelectMenuProps & { isCompact?: boolean }) => `
  width: 100%;
  ${props.isCompact && 'div > div { padding: 2px!important; }'}
`);
